package com.parmartechnologies.core.feature.sale.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class Sale @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("invoice_id") var InvoiceID: String = "",
    @SerialName("product_id") var ProductID: String = "",
    @SerialName("inventory_id") var InventoryID: String = "",
    @SerialName("bar_code") var Barcode: ArrayList<String> = arrayListOf(),
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("customer_name") var CustomerName: String = "",
    @SerialName("customer_id") var CustomerID: String = "",
    @SerialName("customer_mobile") var CustomerMobile: String = "",
    @SerialName("vehicle_number") var VehicleNumber: String = "",
    @SerialName("product_name") var ProductName: String = "",
    @SerialName("payment_mode") var PaymentMode: String = "",
    @SerialName("quantity") var Quantity: Int = 0,
    @SerialName("price") var Price: Float = 0f,
    @SerialName("sale_price") var SalePrice: Float = 0f,
    @SerialName("discount") var Discount: Float = 0f,
    @SerialName("sgst") var SGST: Double = 0.0,
    @SerialName("cgst") var CGST: Double = 0.0,
    @SerialName("igst") var IGST: Double = 0.0,
    @SerialName("cess") var CESS: Double = 0.0,
    @SerialName("vat") var VAT: Double = 0.0,
    @SerialName("sgst_value") var SGSTValue: Double = 0.0,
    @SerialName("cgst_value") var CGSTValue: Double = 0.0,
    @SerialName("igst_value") var IGSTValue: Double = 0.0,
    @SerialName("cess_value") var CESSValue: Double = 0.0,
    @SerialName("vat_value") var VATValue: Double = 0.0,
    @SerialName("tax") var Tax: Double = 0.0,
    @SerialName("final_price") var FinalPrice: Double = 0.0,
    @SerialName("sale_date") var SaleDate: String = "",
    @SerialName("sale_time") var SaleTime: Long = 0,
): BaseDataClass()
